/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedShippingInfoLink_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedBlurbShipping_viewer$ref: FragmentReference;
export type PdpSharedBlurbShipping_viewer = {|
  +$fragmentRefs: PdpSharedShippingInfoLink_viewer$ref,
  +$refType: PdpSharedBlurbShipping_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbShipping_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4cf15ba4689b43624455f8bddad665f4';
module.exports = node;
